import { useMutation } from '@apollo/client';
import { get, reject } from 'lodash';
import * as immutable from 'object-path-immutable';
import { useIntl, defineMessages } from 'react-intl';

import toast from 'helpers/toast';
import { TASK_LIST_REMOVE_ASSIGNMENT } from '../graphql/mutations.graphql';
import { GET_TASK_LIST_ASSIGNED_USERS } from '../graphql/queries.graphql';

const messages = defineMessages({
  successMessage: {
    id: 'Projects.taskList.assign.removeTaskListAssignment.successMessage',
    defaultMessage: 'User successfully unassigned.',
    description: 'Toast message on successful tasklist assignment',
  },
  errorMessage: {
    id: 'Projects.taskList.assign.removeTaskListAssignment.errorMessage',
    defaultMessage:
      'There was an error unassigning a user. Please reload the page and try again',
    description: 'Toast message on an error on tasklist assignmentt',
  },
});

const useTaskListRemoveAssignment = ({ taskListId }) => {
  const intl = useIntl();
  const [removeTaskListAssignment, { loading, error }] = useMutation(
    TASK_LIST_REMOVE_ASSIGNMENT,
    {
      update: (cache, { data }) => {
        const cachedData = cache.readQuery({
          query: GET_TASK_LIST_ASSIGNED_USERS,
          variables: { id: taskListId },
        });
        const cachedNodes = get(
          cachedData,
          'viewer.taskList.assignedUsers.nodes',
          [],
        );
        const unassignedUser = get(
          data,
          'taskListAssignmentDelete.unassignedUser',
        );
        if (unassignedUser === null) return;
        const updatedNodes = reject(cachedNodes, unassignedUser, 'id');
        const updatedData = immutable.set(
          cachedData,
          'viewer.taskList.assignedUsers.nodes',
          updatedNodes,
        );
        cache.writeQuery({
          query: GET_TASK_LIST_ASSIGNED_USERS,
          variables: { id: taskListId },
          data: updatedData,
        });
      },
      onCompleted: () => {
        toast.success(intl.formatMessage(messages.successMessage));
      },
      onError: () => {
        toast.error(intl.formatMessage(messages.errorMessage));
      },
    },
  );
  return { removeTaskListAssignment, loading, error };
};

export default useTaskListRemoveAssignment;
